import { commonBlotterApiConnector } from 'apiConnector/blotters';
import { BlotterItemDetails } from 'models/blotters/BlotterItemDetails';
import { useEffect, useReducer } from 'react';
import { httpClient } from 'utils/http/httpClient';

type State = {
  details: BlotterItemDetails | null;
  loading: boolean;
  error: unknown;
};

type Action =
  | { type: 'LOADING' }
  | { type: 'SUCCESS'; payload: BlotterItemDetails }
  | { type: 'ERROR'; payload: unknown }
  | { type: 'RESET' };

function reducer(state: State, action: Action): State {
  switch (action.type) {
    case 'LOADING':
      return { details: null, loading: true, error: null };
    case 'SUCCESS':
      return { details: action.payload, loading: false, error: null };
    case 'ERROR':
      return { details: null, loading: false, error: action.payload };
    case 'RESET':
      return { details: null, loading: false, error: null };
    default:
      return state;
  }
}

const initialState: State = {
  details: null,
  loading: false,
  error: null,
};

export function useQuoteDetailsQuery(quoteId?: string, disabled = false) {
  const [state, dispatch] = useReducer(reducer, initialState);

  useEffect(() => {
    if (!quoteId || disabled) {
      dispatch({ type: 'RESET' });
      return;
    }
    dispatch({ type: 'LOADING' });
    const connector = commonBlotterApiConnector(httpClient);
    const subscription = connector.getItemDetails(quoteId, 'quotes').subscribe({
      next: data => dispatch({ type: 'SUCCESS', payload: data }),
      error: err => dispatch({ type: 'ERROR', payload: err }),
    });
    return () => subscription.unsubscribe();
  }, [quoteId, disabled]);

  return state;
}
